var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMockTestUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 24,
    viewBox: "0 0 197 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.227649 18.0582C29.7663 8.31041 65.2516 5.27372 98.3712 5.97215C132.282 6.67587 165.547 11.9557 195.883 21.4492C198.443 22.2488 196.191 24.6377 193.647 23.838C163.599 14.4011 130.624 9.16137 97.0101 8.4825C63.6312 7.8043 32.1968 12.3998 0.567918 18.6048C0.0980213 18.6959 -0.226044 18.2404 0.227649 18.0987V18.0582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86561 11.1042C46.2767 -1.21463 95.1783 -2.77346 138.409 3.92751C140.029 4.19069 139.381 5.81024 137.696 5.55718C92.9423 -1.09318 49.1447 2.0245 6.17348 11.5698C5.75219 11.6609 5.46053 11.2358 5.86561 11.1042Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMockTestUnderline);
export default __webpack_public_path__ + "static/media/mockTestUnderline.6f906047267614d93eedcc84644ac079.svg";
export { ForwardRef as ReactComponent };